export default {
  methods: {
    getSeoHead(seoData) {
      if (!seoData) return {}

      // Safe access untuk SSR
      const appUrl =
        typeof process !== 'undefined' && process.env && process.env.APP_URL
          ? process.env.APP_URL
          : 'https://sitrendi.com'

      let currentUrl = appUrl + '/'
      if (typeof this !== 'undefined' && this.$route && this.$route.path) {
        currentUrl = appUrl + this.$route.path
      }

      const head = {
        title: seoData.title || process.env.APP_NAME || 'SiTrendi',
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: seoData.meta_description || '',
          },
        ],
        link: [],
      }

      // Keywords meta tag (if provided)
      if (seoData.meta_keywords) {
        head.meta.push({
          hid: 'keywords',
          name: 'keywords',
          content: seoData.meta_keywords,
        })
      }

      // Robots meta tag
      if (seoData.robots) {
        head.meta.push({
          hid: 'robots',
          name: 'robots',
          content: seoData.robots || 'index,follow',
        })
      }

      // Author meta tag
      if (seoData.author) {
        head.meta.push({
          hid: 'author',
          name: 'author',
          content: seoData.author,
        })
      }

      // Open Graph Tags
      if (seoData.og_title || seoData.title) {
        head.meta.push({
          hid: 'og:title',
          property: 'og:title',
          content: seoData.og_title || seoData.title || '',
        })
      }

      if (seoData.og_description || seoData.meta_description) {
        head.meta.push({
          hid: 'og:description',
          property: 'og:description',
          content: seoData.og_description || seoData.meta_description || '',
        })
      }

      if (seoData.og_image) {
        head.meta.push({
          hid: 'og:image',
          property: 'og:image',
          content: seoData.og_image,
        })
      }

      if (seoData.og_type) {
        head.meta.push({
          hid: 'og:type',
          property: 'og:type',
          content: seoData.og_type || 'website',
        })
      }

      head.meta.push({
        hid: 'og:url',
        property: 'og:url',
        content: seoData.og_url || currentUrl,
      })

      // Twitter Card Tags
      if (seoData.twitter_card) {
        head.meta.push({
          hid: 'twitter:card',
          name: 'twitter:card',
          content: seoData.twitter_card || 'summary_large_image',
        })
      }

      if (seoData.twitter_title || seoData.title) {
        head.meta.push({
          hid: 'twitter:title',
          name: 'twitter:title',
          content: seoData.twitter_title || seoData.title || '',
        })
      }

      if (seoData.twitter_description || seoData.meta_description) {
        head.meta.push({
          hid: 'twitter:description',
          name: 'twitter:description',
          content: seoData.twitter_description || seoData.meta_description || '',
        })
      }

      if (seoData.twitter_image || seoData.og_image) {
        head.meta.push({
          hid: 'twitter:image',
          name: 'twitter:image',
          content: seoData.twitter_image || seoData.og_image || '',
        })
      }

      // Canonical URL
      if (seoData.canonical_url) {
        head.link.push({
          hid: 'canonical',
          rel: 'canonical',
          href: seoData.canonical_url,
        })
      }

      // Store structured data for later use
      if (seoData.structured_data) {
        head.__jsonld = seoData.structured_data
      }

      return head
    },
  },
}
